import { createRouter, createWebHistory } from "vue-router";
import { SecureStorage } from '@/utils/secureStorage';
import apiClient from '@/api/client';
import HomeView from "@/views/HomeView.vue";
import LoginView from "@/views/Login.vue";
import SignUpView from "@/views/SignUp.vue";
import PasswordView from "@/views/Password.vue";
//Settings
import CompanyConfig from "@/views/settings/CompanyConfig.vue";
import BranchesIndex from "@/views/settings/branches/Index.vue";
import Profile from "@/views/settings/Profile.vue";
import UserIndex from "@/views/settings/users/Index.vue";
import TiersSettingsIndex from "@/views/settings/tiers/Index.vue";
//Orders
import OrdersCreateIndex from "@/views/fleet/orders/create/Index.vue"
import OrdersCurrentsIndex from "@/views/fleet/orders/currents/Index.vue"
//Inventory
import InventoryConfig from "@/views/inventory/settings/Config.vue";
import SuppliersIndex from "@/views/inventory/suppliers/Index.vue";
import CategoriesIndex from "@/views/inventory/settings/categories/Index.vue";
import WarehousesIndex from "@/views/inventory/settings/warehouses/Index.vue";
import UnitsIndex from "@/views/inventory/settings/units/Index.vue";
//import ProductsIndex from "@/views/inventory/products/Index.vue";
import PurchasesIndex from "@/views/inventory/purchases/Index.vue";
import StocksIndex from "@/views/inventory/stocks/Index.vue";

//Credits
import ChargesIndex from "@/views/loans/credits/charges/Index.vue";
import FundingIndex from "@/views/loans/credits/funding/Index.vue";
import CollateralIndex from "@/views/loans/credits/collateral/Index.vue";
import CreditsIndex from "@/views/loans/credits/Index.vue";
import CollateralsIndex from "@/views/loans/collaterals/Index.vue";
import CommitteeIndex from "@/views/loans/credits/committee/Index.vue";
import DisbursementIndex from  "@/views/loans/credits/disbursement/Index.vue";
import StatementsIndex from  "@/views/loans/credits/statements/Index.vue";
import CredRevertionsIndex from "@/views/loans/credits/revertions/Index.vue";
import ChangeDate from "@/views/loans/credits/settings/ChangeDate.vue";
import PortfolioReportView from "@/views/loans/reports/PortfolioReportView.vue";
import Portfolio50ReportView from "@/views/loans/reports/Portfolio50ReportView.vue";
import PortfolioRiskReportView from "@/views/loans/reports/PortfolioRiskReportView.vue";
//Customers
import Customers from "@/views/customers/Index.vue";
//Cash
import CashIndex from "@/views/recovery/cash/Index.vue";
import CashRevertionsIndex from "@/views/recovery/revertions/Index.vue"
//Accounting
import AccountCatalogIndex from "@/views/accounting/catalog/Index.vue";
import AccountEntryIndex from "@/views/accounting/entries/Index.vue";
//Clients
import ClientDashboardIndex from "@/views/tenants/Dashboard.vue";
import AgentsIndex from  "@/views/tenants/agents/Index.vue";
import InstancesIndex from  "@/views/tenants/instances/Index.vue";
import ConversationsIndex from  "@/views/tenants/conversations/Index.vue";
import ProductsIndex from  "@/views/tenants/products/Index.vue";
import LeadsIndex from "@/views/tenants/leads/Index.vue";
import ClientBilling from "@/views/tenants/billing/Billing.vue";
import ClientBillingSuccess from "@/views/tenants/billing/Success.vue";
import ClientBillingCancelled from "@/views/tenants/billing/Cancelled.vue";
//Admin
import MetricsIndex from "@/views/admin/dashboard/Index.vue";
import PlansIndex from "@/views/admin/settings/plans/Index.vue";
import UsersIndex from "@/views/admin/settings/users/Index.vue";
import AdminBillingIndex from "@/views/admin/billing/Index.vue";
const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
    meta: { requiresAuth: true }
  },
  {
    path: "/about",
    name: "about",
    component: () => import("../views/AboutView.vue"),
    meta: { requiresAuth: true }
  },
  // --- NUEVA RUTA DE CONFIGURACIÓN ---
  {
    path: "/settings/company", // Esta ruta debe coincidir con la de modulesConfig.js
    name: "settings",
    component: CompanyConfig,
    meta: { requiresAuth: true }
  },
  {
    path: "/settings/branches", // Esta ruta debe coincidir con la de modulesConfig.js
    name: "branches",
    component: BranchesIndex,
    meta: { requiresAuth: true }
  },
  {
    path: "/profile",
    name: "profile",
    component: Profile,
    meta: { requiresAuth: true }
  },
  {
    path: "/settings/users",
    name: "users",
    component: UserIndex,
    meta: { requiresAuth: true }
  },
  {
    path: "/settings/service-tiers",
    name: "service-tiers",
    component: TiersSettingsIndex,
    meta: { requiresAuth: true }
  },
  //ORDERS
  {
    path: "/orders/create",
    name: "orders-create",
    component: OrdersCreateIndex,
    meta: { requiresAuth: true }
  },
  {
    path: "/orders/currents",
    name: "orders-currents",
    component: OrdersCurrentsIndex,
    meta: { requiresAuth: true }
  },
  // -----------------------------------
  {
    path: "/signup",
    name: "signup",
    component: SignUpView,
    meta: {
      requiresAuth: false,
      layout: 'empty'
    }
  },
  {
    path: "/login",
    name: "login",
    component: LoginView,
    meta: {
      requiresAuth: false,
      layout: 'empty'
    }
  },
  {
    path: "/password",
    name: "password",
    component: PasswordView,
    meta: {
      requiresAuth: false,
      layout: 'empty'
    }
  },
  //DRIVERS

  //INVENTORY
  {
    path: "/inventory/config",
    name: "inventory-config",
    component: InventoryConfig,
    meta: { requiresAuth: true }
  },{
    path: "/inventory/suppliers/",
    name: "suppliers",
    component: SuppliersIndex,
    meta: { requiresAuth: true }
  },
  {
    path: "/inventory/categories/",
    name: "categories",
    component: CategoriesIndex,
    meta: { requiresAuth: true }
  },
  {
    path: "/inventory/warehouses/",
    name: "warehouses",
    component: WarehousesIndex,
    meta: { requiresAuth: true }
  },
  {
    path: "/inventory/units/",
    name: "units",
    component: UnitsIndex,
    meta: { requiresAuth: true }
  },
  {
    path: "/inventory/purchases/",
    name: "purchases",
    component: PurchasesIndex,
    meta: { requiresAuth: true }
  },
  {
    path: "/inventory/stocks/",
    name: "stocks",
    component: StocksIndex,
    meta: { requiresAuth: true }
  },
  //Credits
  {
    path: "/credits/applications/",
    name: "credits",
    component: CreditsIndex,
    meta: { requiresAuth: true }
  },
  {
    path: "/credits/collaterals/",
    name: "collaterals",
    component: CollateralsIndex,
    meta: { requiresAuth: true }
  },
  {
    path: "/credits/disbursement/",
    name: "disbursement",
    component: DisbursementIndex,
    meta: { requiresAuth: true }
  },
  {
    path: "/credits/committee/",
    name: "committee",
    component: CommitteeIndex,
    meta: { requiresAuth: true }
  },
  {
    path: "/credits/statements/",
    name: "statements",
    component: StatementsIndex,
    meta: { requiresAuth: true }
  },
  {
    path: "/credits/revertions/",
    name: "credits-revertions",
    component: CredRevertionsIndex,
    meta: { requiresAuth: true }
  },
  {
    path: "/credits/reports/portofolio-review",
    name: "portofolio_review",
    component:PortfolioReportView,
    meta: { requiresAuth: true }
  },
  {
    path: "/credits/reports/portofolio-50-review",
    name: "portofolio_50_review",
    component:Portfolio50ReportView,
    meta: { requiresAuth: true }
  },
  {
    path: "/credits/reports/portofolio-risk-review",
    name: "portofolio_risk_review",
    component:PortfolioRiskReportView,
    meta: { requiresAuth: true }
  },
  //Customers
  {
    path: "/customers/index/",
    name: "customers",
    component: Customers,
    meta: { requiresAuth: true }
  },
  //Cash
  {
    path: "/recovery/cash/index/",
    name: "cash",
    component: CashIndex,
    meta: { requiresAuth: true }
  },
  {
    path: "/recovery/revertions/",
    name: "cash-revertions",
    component: CashRevertionsIndex,
    meta: { requiresAuth: true }
  },
  //Accounting
  {
    path: "/accounting/catalog",
    name: "account_catalog",
    component: AccountCatalogIndex,
    meta: { requiresAuth: true }
  },
  {
    path: "/accounting/entry",
    name: "account_entry",
    component: AccountEntryIndex,
    meta: { requiresAuth: true }
  },
  {
    path:"/settings/change-date",
    name: "change_date",
    component: ChangeDate,
    meta: { requiresAuth: true }
  },
  //Products
  {
    path: "/settings/products/",
    name: "financial_products",
    component: ProductsIndex,
    meta: { requiresAuth: true }
  },
  {
    path: "/settings/charges/",
    name: "charges_and_fees",
    component: ChargesIndex,
    meta: { requiresAuth: true }
  },
  {
    path: "/settings/funding-sources/",
    name: "funding",
    component: FundingIndex,
    meta: { requiresAuth: true }
  },
  {
    path: "/settings/collateral-types/",
    name: "collaeral",
    component: CollateralIndex,
    meta: { requiresAuth: true }
  },
  // --- CLIENTES (Workspace) ---
  {
    path: "/client/dashboard",
    name: "client-dashboard",
    component: ClientDashboardIndex,
    meta: { requiresAuth: true, allowedRoles: [1, 3] } // <-- Admin y Cliente
  },
  {
    path: "/client/billing",
    name: "client-billing",
    component: ClientBilling,
    meta: { requiresAuth: true, allowedRoles: [1, 3] } // <-- Admin y Cliente
  },
  {
    path: "/client/billing/success",
    name: "client-billing-success",
    component: ClientBillingSuccess,
    meta: { requiresAuth: true, allowedRoles: [1, 3] } // <-- Admin y Cliente
  },
  {
    path: "/client/billing/cancelled",
    name: "client-billing-cancelled",
    component: ClientBillingCancelled,
    meta: { requiresAuth: true, allowedRoles: [1, 3] } // <-- Admin y Cliente
  },
  {
    path: "/client/conversations",
    name: "conversations",
    component: ConversationsIndex,
    meta: { requiresAuth: true, allowedRoles: [1, 3] } // <-- Admin y Cliente
  },
  {
    path: "/client/agents",
    name: "agents",
    component: AgentsIndex,
    //meta :{ requiresAuth: false, layout: 'empty'}
    meta: { requiresAuth: true, allowedRoles: [1, 3] }
  },
  {
    path: "/client/instances",
    name: "instances",
    component: InstancesIndex,
    meta: { requiresAuth: true, allowedRoles: [1, 3] }
  },
 {
    path: "/client/products",
    name: "products",
    component: ProductsIndex,
    meta: { requiresAuth: true, allowedRoles: [1, 3] }
  },
  {
    path: "/client/leads",
    name: "leads",
    component: LeadsIndex,
    meta: { requiresAuth: true, allowedRoles: [1, 3] }
  },
  // --- ADMIN GOAT (Control SaaS) ---
  {
    path: "/settings/metrics/",
    name: "Metrics",
    component: MetricsIndex,
    meta: { requiresAuth: true, allowedRoles: [1] } // <-- SOLO ADMIN
  },
  {
    path: "/settings/plans/",
    name: "Plans",
    component: PlansIndex,
    meta: { requiresAuth: true, allowedRoles: [1] } // <-- SOLO ADMIN
  },
  {
    path: "/settings/billing/",
    name: "Admin-Billing",
    component: AdminBillingIndex,
    meta: { requiresAuth: true, allowedRoles: [1] } // <-- SOLO ADMIN
  },
  {
    path: "/settings/users/",
    name: "Users",
    component: UsersIndex,
    meta: { requiresAuth: true, allowedRoles: [1] } // <-- SOLO ADMIN
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

// Función auxiliar para parsear fechas de MySQL (YYYY-MM-DD HH:MM:SS) a timestamp
function parseSqlDate(dateStr) {
  if (!dateStr) return 0;
  const isoStr = String(dateStr).trim().replace(' ', 'T');
  const timestamp = new Date(isoStr).getTime();
  return isNaN(timestamp) ? 0 : timestamp;
}

// GUARDIA DE NAVEGACIÓN
router.beforeEach(async (to, from, next) => {
  const isAuthenticated = !!localStorage.getItem('neurals_token');
  let currentUser = SecureStorage.getItem('neurals_user');
  const userRole = Number(currentUser?.role_id);

  // 1. Verificación básica
  if (to.meta.requiresAuth && !isAuthenticated) {
    return next({ name: 'login' });
  }

  if ((to.name === 'login' || to.name === 'signup') && isAuthenticated) {
    return userRole === 3 ? next({ path: '/client/agents' }) : next({ name: 'home' });
  }

  if (!to.meta.requiresAuth) {
    return next();
  }

  // 2. Redirección de inicio
  if (to.path === '/') {
    return userRole === 3 ? next({ path: '/client/agents' }) : next();
  }

  // 3. RBAC
  if (to.meta.allowedRoles && !to.meta.allowedRoles.includes(userRole)) {
    return userRole === 3 ? next({ path: '/client/agents' }) : next({ path: '/' });
  }

  // 4. Validación de Cliente (role_id === 3)
  if (userRole === 3) {
    const isBillingRoute = to.name === 'client-billing' || to.path === '/client/billing';

    if (isBillingRoute) {
      return next();
    }

    // Refrescar datos desde la DB si el almacenamiento local dice que no está activo
    if (currentUser?.subscription_status !== 'active') {
      try {
        const res = await apiClient.get('/get_my_subscription_status', { params: { user_id: currentUser.id } });
        if (res.data?.data) {
          currentUser = { ...currentUser, ...res.data.data };
          SecureStorage.setItem('neurals_user', currentUser);
        }
      } catch (e) {
        console.error('Error sincronizando suscripción', e);
      }
    }

    const hasPlan = currentUser?.is_premium && parseInt(currentUser.is_premium) > 0;
    if (!hasPlan) {
      return next({ name: 'client-billing' });
    }

    const now = Date.now();
    const trialEnds = parseSqlDate(currentUser?.trial_ends_at);
    const subExpires = parseSqlDate(currentUser?.subscription_expires_at);

    const isTrialActive = currentUser?.subscription_status === 'trial' && trialEnds > now;
    const isSubActive = currentUser?.subscription_status === 'active' && (subExpires > now || subExpires === 0);

    if (!isTrialActive && !isSubActive) {
      return next({ name: 'client-billing' });
    }
  }

  next();
});

export default router;